import axios from 'axios';
import config from '../config/config';

export const touroService = {
    get,
};
function get(apiEndpoint) {
    return axios.get(config.baseUrl + apiEndpoint, getOptions())
        .then((response) => {
            return response;
        }).catch((err) => {
            console.log(err);
        })
}
function getOptions() {
    let options = {};
    //let authdata = window.btoa('gestorrp:gestor2414#');
    var token = localStorage.getItem('token');
    if (token === undefined) {
        token = 'gestorrp:gestor2414#';
    }
    let authdata = window.btoa(token);
    options.headers = { 'Authorization': 'Basic ' + authdata };
    return options;
}